import React from "react";

import "./live-icon.m.css";

const LiveIcon = () => (
  <svg styleName="blinking" width="14" height="14">
    <circle cx="7" cy="7" r="7" fill="#db3a37" />
  </svg>
);

export default LiveIcon;
